import { Component } from '@angular/core';

@Component({
  selector: 'val-noop',
  template: '<!-- noop component -->',
})
export class NoopComponent {}
